import { render } from "./WelcomeDialog.vue?vue&type=template&id=012a179d"
import script from "./WelcomeDialog.vue?vue&type=script&lang=js"
export * from "./WelcomeDialog.vue?vue&type=script&lang=js"

import "./WelcomeDialog.vue?vue&type=style&index=0&id=012a179d&lang=css"

import exportComponent from "/Users/nutsudaploysopon/Desktop/DevFinite/Octopus Co.,Ltd./Ncare/NCare-WebApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__